import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

/**
 * Fetch the general ledger report.
 * @param {Object} filters - { start_date, end_date, transaction_type, party_name }
 */
export const getLedgerReport = async (filters = {}) => {
  // Remove empty values
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, v]) => v !== "" && v !== null && v !== undefined)
  );
  const response = await axios.get(`${BASE}/reports/ledger`, { params });
  return response.data;
};
